export const catalogRoute = '/catalogs';

export { Catalog } from '../../../shared/components/Catalog/Catalog';
